<template>
  <div class="">
    <form @submit.prevent="onSubmit">

      <b-form-row>

        <form-group class="my-2 col-lg-12" :validations="$v.form.link">
          <div slot-scope="{ errors, invalid }">
            <label>لینک</label>

            <input v-model="form.link" type="text" class="form-control">

            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

        <form-group class="my-2 col-lg-12" :validations="$v.form.xpath">
          <div slot-scope="{ errors, invalid }">
            <label>xpath</label>

            <input v-model="form.xpath" type="text" class="form-control">

            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

        <form-group class="my-2 col-lg-12" :validations="$v.form.crawlerable_column">
          <div slot-scope="{ errors, invalid }">
            <label>محل قرارگیری</label>

            <select :disabled="isInUpdateMode" class="custom-select" v-model="form.crawlerable_column">
              <option value="">یکی از موارد را انتخاب کنید.</option>
              <option v-for="item in CrawlerTypes[crawlerType]['columns']" :value="item.value">{{ item.label }}</option>
            </select>


            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

        <form-group v-if="form.crawlerable_column === 'feature'" class="my-2 col-lg-12"
                    :validations="$v.form.crawlerable_column_id">
          <div slot-scope="{ errors, invalid }">
            <label>نام ویژگی</label>

            <select :disabled="isInUpdateMode" required class="custom-select" v-model="form.crawlerable_column_id">
              <option value="">انتخاب یکی از ویژگی های محصول</option>
              <option v-for="item in productFeatures" :value="item.id">{{
                  productFeatureName(product, item.id)
                }}
              </option>
            </select>


            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

        <form-group v-if="form.crawlerable_column === 'feature' && isFeatureVariation(form.crawlerable_column_id)"
                    class="my-2 col-lg-12"
                    :validations="$v.form.crawlerable_column_id">
          <div slot-scope="{ errors, invalid }">
            <label>بخش ویژگی متغییر</label>

            <select :disabled="isInUpdateMode" required class="custom-select" v-model="form.extra.position">
              <option v-for="(index,item) in crawlerPositionExtraOptions" :value="item">
                {{ index }}
              </option>
            </select>


            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

      </b-form-row>


      <b-button class="w-100 my-2" pill type="submit">ثبت</b-button>

    </form>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import FormGroup from "../../validator/FormGroup.vue";
import FormErrorsManager from "../../validator/FormErrorsManager.vue";
import {required, url} from "vuelidate/lib/validators";
import {crawlerPositionExtraOptions, CrawlerTypes} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Crawler'
import {productFeatureName, checkValueIsNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";

export default {
  name: "CrawlerForm",
  components: {
    FormGroup,
    FormErrorsManager,
  },
  props: {
    crawler: {
      default: null
    },
    crawlerType: {},
    crawlerableId: {},
    product: {},
  },
  data() {
    return {
      form: {
        crawlerable_type: this.crawlerType,
        crawlerable_id: this.crawlerableId,
        link: '',
        xpath: '',
        crawlerable_column: '',
        crawlerable_column_id: '',
        extra: {
          position: 'price'
        },
      },
      CrawlerTypes,
      productFeatures: [],
      crawlerPositionExtraOptions
    }
  },
  validations: {
    form: {
      link: {required, url},
      xpath: {required,},
      crawlerable_column: {required},
      crawlerable_column_id: {},
    },
  },
  computed: {
    isInUpdateMode() {
      return this.crawler !== null
    },
    productFeaturesComputed() {
      return Object.keys(this.product).includes('features') ? this.product.features : this.product.feature_product
    }
  },
  methods: {
    productFeatureName,
    checkValueIsNumber,
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {
      if (this.invalid()) {

        if (this.isInUpdateMode) {
          this.$store.dispatch('Crawler/updateCrawler', this.form)
        } else {

          this.$store.dispatch('Crawler/createCrawler', this.form)
        }


      }
    },
    productFeature() {
      // setup features
      let productFeatures = this.productFeaturesComputed
      productFeatures = productFeatures.filter(item => {
        if (((item.variation == 1 && item.sub_product == 1) || item.variation == 0) && this.checkValueIsNumber(item.id)) {
          return item
        }
      })

      return productFeatures
    },
    isFeatureVariation() {
      let productFeatures = this.productFeaturesComputed

      let feature = productFeatures.find(item => {
        if (item.id == this.form.crawlerable_column_id) {
          return item
        }
      })
      return feature == undefined ? false : feature.variation == 1
    }
  },
  mounted() {
    if (this.crawler != null) {
      this.form = this.crawler
    }
    this.productFeatures = this.productFeature()
  }
}
</script>

<style scoped>

</style>